































































































































































































































































































































































































































import { Component, Vue } from "vue-property-decorator";
import Header from "@/components/Header.vue";
import moment from "moment";
import * as util from "@/service/util";
import { WorkProgressStateData } from "@/model/WorkProgressStateData";
import requestService from "@/service/requestService";
import { Daisha } from "@/model/Daisha";
import { WorkShubetsuCategory } from "@/model/WorkShubetsuCategory";
import { ReservationItem } from "@/model/ReservationItem";
import { WorkShubetsu } from "@/model/WorkShubetsu";
import { ReservationService } from "@/service/ReservationService";
import { Action, Getter } from "vuex-class";
import { MESSAGE } from "@/model/Message";
import vuedraggable from "vuedraggable";
import ConfirmDialog from "@/components/common/ConfirmDialog.vue";
/** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
import { FunctionSettingService } from "@/service/FunctionSettingService";
/** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */

@Component({
  components: {
    Header,
    draggable: vuedraggable,
    ConfirmDialog
  }
})
export default class Reservation extends Vue {
  currentTab: number = 0;
  currentDay: number = 6;
  currentPage: number = 1;
  dialogVisible: boolean = false;
  dialogWorkTypeVisible: boolean = false;
  dialogData: any = {};
  workTypeCategories: WorkShubetsuCategory[] = [];
  workCounts: number[] = [];
  workCountsPerDay: number[] = [];
  arrReserveByCategory: any = [];
  arrWorkCounts: number[][] = [];
  worksForSelect: any = [];
  arrDay: any = [];
  startDay: any;
  oldStartDay: any = null;
  reserveList: any = [];
  reserveListAll: any = [];
  reserveByCategory: ReservationItem[][] = [];
  workCategoryNo: string = "0";
  dateSelected: string = "";
  workTypeList: WorkShubetsu[] = [];
  filterKey: string;
  filterValue: string;
  reservService: ReservationService;
  reqService: requestService;
  worksLoading: boolean = true;
  reservationsLoading: boolean = true;
  Message: any = {};
  timerRequestData: any = null;
  rangeDay: number = 7;
  showDialogSetting: boolean = false;
  dataSetting: any = [];
  dataDisplay: any = [];
  hoverIndex: number = -1;
  errorMsg: string = "";
/** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
  functionSetting: FunctionSettingService;
/** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */

  @Action("setUketsukeCd", { namespace: "ReservationDetail" })
  setUketsukeCd: any;
  @Action("clearState", { namespace: "ReservationDetail" })
  clearState: any;
  @Action("clearState", { namespace: "InspectionDetail" })
  clearStateInspectionDetail: any;
  @Action("clearState", { namespace: "SubHeader" })
  clearStateTime: any;
  @Action("clearState", { namespace: "Inspect" })
  clearStateInspect: any;
  @Action("clearState", { namespace: "CarSelection" })
  clearStateCarSelection: any;

  @Getter("uketsukeCd", { namespace: "ReservationDetail" })
  uketsukeCd: any;
  @Getter("uketsukeExtendsId", { namespace: "ReservationDetail" })
  uketsukeExtendsId: number;

  @Action("clearState", { namespace: "WorkOrder" })
  clearStateWorkOrder: any;

  /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [START] */
  @Getter("isCanQuickMitsumori", { namespace: "FunctionSetting"} )
  isCanQuickMitsumori: any;
  /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [END] */

  $refs!: {
    errorDialog: ConfirmDialog;
  };

  created() {
    this.Message = MESSAGE;
    this.reservService = new ReservationService();
    this.reqService = new requestService();
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
    this.functionSetting = new FunctionSettingService();
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
    moment.locale("ja");
    this.setDateToday();
    this.clearState();
    this.reservService.getWorkShubetsuCategories().then((res: any) => {
      if (res && res.length > 0) {
        this.workTypeCategories = res;
        this.worksForSelect = Array.from(res).slice(1);
      }
      this.requestData();
    });

    this.reqService.getReservationSetting().then(res => {
      if (res) {
        this.dataSetting = res;
        this.setDataDisplay();
      }
    });

  }

  openColsSettingDialog() {
    this.reqService.getReservationSetting().then(res => {
      if (res) {
        this.dataSetting = res;
        this.setDataDisplay();
      }
    });
    this.showDialogSetting = true;
  }

  setDateToday() {
    this.oldStartDay = this.startDay;
    this.startDay = moment().add(-this.rangeDay, "d");
    this.dateSelected = moment().format("YYYYMMDD");
    this.setArrDay();
    this.currentDay = this.rangeDay;
  }

  selectToday() {
    this.setDateToday();
    if (this.oldStartDay.format("YYYYMMDD") != this.startDay.format("YYYYMMDD")) {
      this.requestData();
    } else {
      this.setData();
    }
  }

  setData() {
    this.filterReserveList();
    if (this.arrReserveByCategory.length > 0) {
      this.workCounts = this.arrWorkCounts[this.currentDay];
      this.reserveByCategory = this.arrReserveByCategory[this.currentDay];
      this.reserveList = this.reserveByCategory[this.currentTab];
      // this.onSetPage(1);
      this.workCountsPerDay = this.reservService.getWorkCountsPerDay(
        this.arrWorkCounts,
        this.currentTab
      );
    } else {
      const n = this.rangeDay * 2 + 1;
      let workCountsPerDay = Array(n).fill(0);
      this.$set(this, "workCountsPerDay", workCountsPerDay);
    }
   
    this.reservationsLoading = false;
  }

  setArrDay() {
    this.arrDay = this.reservService.getDayTabs(this.startDay, this.rangeDay);
  }

  requestData() {
    this.reserveListAll = [];
    this.reservationsLoading = true;
    if (this.timerRequestData) {
      clearTimeout(this.timerRequestData);
      this.timerRequestData = null;
    }
    this.timerRequestData = setTimeout(() => {
      this.reservService
        .requestData(
          this.startDay,
          this.workTypeCategories.length,
          this.rangeDay
        )
        .then((res: any) => {
          if (res.length > 0) {
            this.reserveListAll = res;
            this.setData();
          } else {
            this.setData();
            this.reservationsLoading = false;
          }
        },(error: any) => {
          if (error) {
            this.setData();
            this.onError(error);
          }
        });
    }, 300);
  }

  isActive(index: number) {
    return this.currentTab === index;
  }

  isActiveDay(index: number) {
    return this.currentDay === index;
  }

  selectTab(tab: WorkShubetsuCategory, index: number) {
    this.currentTab = index;
    this.workCategoryNo = tab.workShubetsuCategoryId.toString();
    this.currentPage = 1;
    this.setData();
  }

  selectDay(day: any, index: number) {
    this.currentDay = index;
    this.dateSelected = day.value;
    this.currentPage = 1;
    this.setData();
  }

  setDateSelected() {
    if (this.arrDay.length > 0) {
      this.dateSelected = this.arrDay[this.currentDay].value;
    }
  }
  prevWeek() {
    this.currentDay = this.rangeDay;
    this.startDay.add(-this.rangeDay, "d");
    this.setArrDay();
    this.setDateSelected();
    this.requestData();
  }

  nextWeek() {
    this.currentDay = this.rangeDay;
    this.startDay.add(this.rangeDay, "d");
    this.setArrDay();
    this.setDateSelected();
    this.requestData();
  }

  indexMethod(index: number) {
    return index + 1;
  }

  rowClassName(rowobj: any, isNew: boolean = false) {
    let row: any;
    if (rowobj.row) {
      row = rowobj.row;
    } else {
      row = rowobj;
    }
    if (row.progressKbn == 3 || row.sknWorkProgressState == 14) {
      return "gray-bg";
    }
    if (row.sknState == "割当中") {
      return "red-bg";
    }
    if (row.progressNm == "納車") {
      return "gray-bg";
    }
    return "";
  }

  onHover(i: number) {
    this.hoverIndex = i;
  }

  onLeave() {
    this.hoverIndex = -1;
  }

  rowWorktypeClassName(rowobj: any) {
    const { rowIndex } = rowobj;
    if (rowIndex % 2 == 1) {
      return "gray-bg";
    }
    return "";
  }

  onClickDetail(row: any, e: any) {
    if (e) {
      e.stopPropagation();
    }
    if(row.progressKbn != 3) {
      this.clearState();
      this.clearStateInspectionDetail();
      this.clearStateTime();
      this.clearStateInspect();
      this.clearStateCarSelection();
      this.clearStateWorkOrder();
      this.setUketsukeCd(row.uketsukeCd);
      this.$router.push({
        name: "customer",
        params: { code: row.uketsukeCd }
      });
    }
  }

  heiseiDate(date: string) {
    return util.getJapanDate(date, "YYYYMMDD");
  }

  getStatusColor(stateId: number) {
    const obj = WorkProgressStateData[stateId];
    if (obj) {
      return obj.color;
    }
    return "";
  }

  // onSetPage(page: number) {
  //   if (
  //     this.reserveListAll.length > 0 &&
  //     this.reserveListAll[this.currentDay].length > 0
  //   ) {
  //     const list = this.reserveByCategory[this.currentTab];
  //     if (list.length > 0) {
  //       const end = page * this.pageSize;
  //       const start = end - this.pageSize;
  //       this.reserveList = list.slice(start, end);
  //     } else {
  //       this.reserveList = [];
  //     }
  //   } else {
  //     this.reserveList = [];
  //   }
  //   this.reservationsLoading = false;
  // }

  get reserveListData() {
    return this.reserveList;
  }

  get reserveListLength() {
    if (this.reserveByCategory && this.reserveByCategory.length > 0) {
      return this.reserveByCategory[this.currentTab].length;
    }
    return 0;
  }

  openDialogDaisha(daisha: Daisha) {
    this.dialogVisible = true;
    if (daisha) {
      const period = {
        period:
          this.heiseiDate(daisha.daishaRentStartYmd) +
          "~" +
          this.heiseiDate(daisha.daishaRentEndYmd)
      };

      this.dialogData = Object.assign(daisha, period);
    }
  }

  getTime(strTime: string) {
    if (strTime) {
      return util.removeLeadingZero(strTime);
    }
    return "";
  }

  onSearch(filterOption: any) {
    if (filterOption) {
      this.filterValue = util.toASCII(filterOption.value);
      this.filterKey = filterOption.key;
      this.setData();
    }
  }

  filterReserveList() {
    let {
      arrWorkCounts,
      arrReserveByCategory
    } = this.reservService.filterReserveList(
      this.reserveListAll,
      this.workTypeCategories,
      this.filterKey,
      this.filterValue
    );
    this.arrWorkCounts = arrWorkCounts;
    this.arrReserveByCategory = arrReserveByCategory;
  }

  onShowDialogWorkType() {
    this.worksLoading = true;
    this.dialogWorkTypeVisible = true;
    this.reqService.getWorkShubetsu().then(
      (res: any) => {
        this.workTypeList = res;
        this.worksLoading = false;
      },
      (err: any) => {
        this.worksLoading = false;
      }
    );
  }

  getTorokubango(row: any): string {
    return (
      row.srPlateAreaNm +
      row.srPlateModelNm +
      row.srPlateKanaNm +
      "<br/>" +
      row.srPlateNo
    );
  }

  onUpdateWorkShubetsu(row: WorkShubetsu) {
    row.changed = true;
  }

  OnChangeWorkCate(row: WorkShubetsu) {
    row.changed = true;
    row.isSelected = true;
  }

  saveWorkType() {
    this.dialogWorkTypeVisible = false;
    this.reservService.saveWorkShubetsu(this.workTypeList).then(
      (msg: any) => {
        this.$message.info(msg);
        this.requestData();
      },
      (error: any) => {
        console.log(error);
        this.$message.error("error");
      }
    );
  }

  disabledChkisSelected(row: WorkShubetsu) {
    return row.workShubetsuCategoryId == null;
  }

  saveDataSetting() {
    this.dataDisplay.forEach((data: any) => {
      this.dataSetting.map((temp: any, index: number) => {
        if (data.columnKey === temp.columnKey) {
          temp.displayOrder = data.displayOrder;
        }
      });
    });
    this.setDataDisplay();
    this.reqService.updateReservationSetting(this.dataSetting);
    this.showDialogSetting = false;
  }

  setDataDisplay() {
    let temp: any[] = [];
    temp.push({
      columnId: "0",
      columnNm: "No",
      columnKey: "no",
      isDisplay: 1,
      displayOrder: 0
    });
    this.dataSetting.forEach((data: any) => {
      if (data.isDisplay === 1) {
        temp.push({ ...data });
      }
    });
    temp.push({
      columnId: "99",
      columnNm: "詳細",
      columnKey: "detail",
      isDisplay: 1,
      displayOrder: 99
    });
    temp.sort((a, b) => (a.displayOrder > b.displayOrder ? 1 : -1));
    this.dataDisplay = [...temp];
  }

  saveOrderCols() {
    this.dataDisplay.map((data: any, i: number) => {
      data.displayOrder = i;
    });
    this.reqService.updateReservationSetting(this.dataDisplay);
  }

  checkMove(event: any) {
    const index: number = event.draggedContext.index;
    const futureIndex: number = event.draggedContext.futureIndex;
    let isMove: boolean = true;
    if (index === 0 || futureIndex === 0) {
      isMove = false;
    }
    if (
      index === this.dataDisplay.length - 1 ||
      futureIndex === this.dataDisplay.length - 1
    ) {
      isMove = false;
    }
    return isMove;
  }

  widthCols(key: string) {
    if (
      key === "sknWorkProgressState" ||
      key === "detail"
    ) {
      return "w65";
    }
    if (key === "nyuukoPlansTime")
      return "w80";
    if (key === "daisha") {
      return "w45";
    }
    if (key === "kkUketsukeNm") {
      return "w160";
    }
    if (key === "nyuukoRireki") {
      return "w60";
    }
    if (key === "srModelNm") {
      return "mw150";
    }
  }

  onError(res: any) {
    this.reservationsLoading = false;
    this.$set(this, "reserveList", []);
    this.$set(this, "reserveListAll", []);
    if (res.status !== 204) {
      if (res.status < 500 && res.rsltComment) {
        this.errorMsg = res.rsltComment;
      } else {
        this.errorMsg = MESSAGE.SystemError;
      }
      this.$refs.errorDialog.onOpen();
    }
  }

  onQuick() {
    this.$router.push({ name: "quickinfo"} );
  }

  get isDebug() {
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [START] */
    // let debug: any = localStorage.getItem("isDebug");
    // return debug == "1";
    // return this.functionSetting.isDebug();
    /** 2021-05-20 sh #6993 preview for Quickmitsumori [END] */
    /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [START] */
    // let debug: any = localStorage.getItem("isDebug");
    // return debug == "1";
    return this.isCanQuickMitsumori;
    /** 2021-07-30 sh #6989 implements quick mitsumori. (priority2) [END] */
  }

  /** 2023-06-30 sh #8385(BQR1118) chagen Katakana from Han to Zen. [START] */
  columnNm(nm: any) {
    return nm
    .replace('入庫予定日時', '入庫予定<br />日時')
    .replace('作業予定時間', '作業予定<br />時間')
    .replace('入庫履歴', '入庫<br />履歴');
  }
  /** 2023-06-30 sh #8385(BQR1118) chagen Katakana from Han to Zen. [END] */
}
